import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppFloatingButton from "./components/WhatsAppFloatingButton";
import DemoModal from "./components/DemoModal";
import BrochureModal from "./components/BrochureModal";
import QuoteModal from "./components/QuoteModal";
import { DemoModalProvider, useDemoModal } from "./contexts/DemoModalContext";
import { BrochureModalProvider, useBrochureModal } from "./contexts/BrochureModalContext";
import { QuoteModalProvider, useQuoteModal } from "./contexts/QuoteModalContext";
import { SiteSettingsProvider } from "./contexts/SiteSettingsContext";

import Home from "./pages/Home";
import LearnLanguage from "./pages/LearnLanguage";
import Services from "./pages/Services";
import WhoWeAre from "./pages/WhoWeAre";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import Payment from "./pages/Payment";
import Contact from "./pages/Contact";
import German from "./pages/German";
import Spanish from "./pages/Spanish";
import Japanese from "./pages/Japanese";
import French from "./pages/French";
import Career from "./pages/Career";
import ScrollToTop from "./components/ScrollToTop";

function AppContent() {
  const { isModalOpen, selectedLanguage, closeModal } = useDemoModal();
  const { isModalOpen: isBrochureModalOpen, selectedLanguage: brochureLanguage, closeModal: closeBrochureModal } = useBrochureModal();
  const { isModalOpen: isQuoteModalOpen, selectedService, closeModal: closeQuoteModal } = useQuoteModal();

  return (
    <>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col bg-canvas text-ink">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/courses" element={<LearnLanguage />} />
            <Route path="/services" element={<Services />} />
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:slug" element={<BlogDetail />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/german" element={<German />} />
            <Route path="/spanish" element={<Spanish />} />
            <Route path="/japanese" element={<Japanese />} />
            <Route path="/french" element={<French />} />
            <Route path="/career" element={<Career />} />
            {/* <Route path="/testimonials" element={<Testimonials />} /> */}
          </Routes>
        </main>
        <Footer />
        {/* <FloatingButtons /> */}
        <WhatsAppFloatingButton />
      </div>
      <DemoModal 
        isOpen={isModalOpen} 
        onClose={closeModal} 
        selectedLanguage={selectedLanguage}
      />
      <BrochureModal 
        isOpen={isBrochureModalOpen} 
        onClose={closeBrochureModal} 
        language={brochureLanguage}
      />
      <QuoteModal 
        isOpen={isQuoteModalOpen} 
        onClose={closeQuoteModal} 
        selectedService={selectedService}
      />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SiteSettingsProvider>
        <DemoModalProvider>
          <BrochureModalProvider>
            <QuoteModalProvider>
              <AppContent />
            </QuoteModalProvider>
          </BrochureModalProvider>
        </DemoModalProvider>
      </SiteSettingsProvider>
    </BrowserRouter>
  );
}

export default App;
